// Patches React.createElement to apply defaultProps (React 19 dropped support).
// The jsx-runtime (jsx/jsxs/jsxDEV) is handled by defaultPropsPlugin in vite.config.ts
// because ESM namespace objects from `import *` are frozen and cannot be mutated.
import React from 'react'

const applyDefaultProps = (type, props) => {
  const defaultProps = type?.defaultProps

  if (!defaultProps || props == null) {
    return props
  }

  let nextProps = props

  Object.keys(defaultProps).forEach(key => {
    if (nextProps[key] !== undefined) {
      return
    }

    if (nextProps === props) {
      nextProps = { ...props }
    }

    nextProps[key] = defaultProps[key]
  })

  return nextProps
}

const SHIM_FLAG = '__TABEO_DEFAULT_PROPS_POLYFILL__'

if (!React[SHIM_FLAG]) {
  const originalCreateElement = React.createElement

  React.createElement = (type, props, ...children) =>
    originalCreateElement(type, applyDefaultProps(type, props), ...children)

  React[SHIM_FLAG] = true
}
